import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { voicesAPI, projectsAPI } from '../services/api';

const Voices = () => {
  const [projects, setProjects] = useState([]);
  const [voices, setVoices] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [projectsRes, voicesRes] = await Promise.all([
        projectsAPI.getAll(),
        voicesAPI.getAvailable()
      ]);
      setProjects(projectsRes.data.projects);
      if (voicesRes.data.success) setVoices(voicesRes.data.voices);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <Layout>
      <div className="px-4 sm:px-0">
        <h1 className="text-3xl font-bold mb-6">Gestión de Voces</h1>
        <div className="card">
          <p className="text-gray-600">
            Configura voces de ElevenLabs para dar la bienvenida a los asistentes.
          </p>
          <p className="text-sm text-gray-500 mt-4">
            Total de proyectos: {projects.length}
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Voices;
